import React, { useState } from "react";
import { PhoneIcon, MessageCircleIcon, MailIcon, MapPinIcon, ClockIcon, Building2Icon, CheckCircle2Icon, SendIcon } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { company } from "../../i18n/translations";
import { SectionHeading } from "../ui/SectionHeading";
import { Reveal } from "../ui/Reveal";
export function Contact() {
  const {
    t
  } = useLanguage();
  const [sent, setSent] = useState(false);
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSent(true);
    (e.target as HTMLFormElement).reset();
  };
  const infoItems = [{
    icon: Building2Icon,
    label: t.contact.companyLabel,
    value: company.legalName
  }, {
    icon: PhoneIcon,
    label: t.contact.phoneLabel,
    value: company.phone,
    href: `tel:${company.phone}`
  }, {
    icon: MessageCircleIcon,
    label: t.contact.whatsappLabel,
    value: company.whatsapp,
    href: company.whatsappLink
  }, {
    icon: MailIcon,
    label: t.contact.emailLabel,
    value: company.email,
    href: `mailto:${company.email}`
  }, {
    icon: MapPinIcon,
    label: t.contact.addressLabel,
    value: t.contact.address,
    href: company.mapUrl
  }, {
    icon: ClockIcon,
    label: t.contact.hoursLabel,
    value: t.contact.hours
  }];
  return <section id="contacto" className="w-full bg-white py-20 sm:py-28" data-id="element-115" data-mp="2g0hs2l94ci3w">
      <div className="max-w-content mx-auto px-4 sm:px-6" data-id="element-116" data-mp="1s92neltvdoph">
        <SectionHeading eyebrow={t.contact.eyebrow} title={t.contact.title} subtitle={t.contact.subtitle} data-id="element-117" data-mp="1sbotsi50xy64" />

        <div className="mt-14 grid lg:grid-cols-2 gap-8 lg:gap-12 items-start" data-id="element-118" data-mp="2281wu6mglodj">
          {/* Info + map */}
          <Reveal data-id="element-119" data-mp="1x7nlofpk9yba">
            <ul className="space-y-5" data-id="element-120" data-mp="1x74635ndvm0f">
              {infoItems.map(item => {
              const Icon = item.icon;
              const content = <>
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-sm bg-navy text-orange" data-id="element-121" data-mp="38msum1gact3c">
                      <Icon size={20} data-id="element-122" data-mp="3fqslpwpys8wh" />
                    </span>
                    <span data-id="element-123" data-mp="3kpc5prkzzam7">
                      <span className="block text-xs font-semibold uppercase tracking-wide text-slate-400" data-id="element-124" data-mp="3kokesu2ci129">
                        {item.label}
                      </span>
                      <span className="block text-navy font-medium leading-snug" data-id="element-125" data-mp="3un9ucg6rr9fc">{item.value}</span>
                    </span>
                  </>;
              return <li key={item.label} data-id="element-126" data-mp="31yuk06yl1fac">
                    {item.href ? <a href={item.href} target={item.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className="flex items-start gap-4 group" data-id="element-127" data-mp="36z0f5x429jx6">
                        <span className="flex items-start gap-4 group-hover:opacity-80 transition-opacity" data-id="element-128" data-mp="2e88k52yqf1bf">
                          {content}
                        </span>
                      </a> : <div className="flex items-start gap-4" data-id="element-129" data-mp="wbwugwxqrj35">{content}</div>}
                  </li>;
            })}
            </ul>

            <div className="mt-8 rounded-sm overflow-hidden border border-slate-200 shadow-sm" data-id="element-130" data-mp="rf6fye1l4vju">
              <iframe title="Google Maps - GRANSACA" src={company.mapEmbed} width="100%" height="260" style={{
              border: 0
            }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-id="element-131" data-mp="mgmq42jvezm7" />
            </div>
          </Reveal>

          {/* Form */}
          <Reveal delay={0.08} data-id="element-132" data-mp="3ly0cn4owvrm">
            <div className="rounded-sm border border-slate-200 bg-slate-50 p-6 sm:p-8" data-id="element-133" data-mp="3uulo19qekv2c">
              {sent ? <div className="flex flex-col items-center justify-center text-center py-14" data-id="element-134" data-mp="3pw0lv4rlc1b9">
                  <CheckCircle2Icon size={56} className="text-orange" data-id="element-135" data-mp="1tsvu1o0kjj0p" />
                  <p className="mt-4 text-navy font-medium max-w-sm" data-id="element-136" data-mp="1yqnvb8n3shhk">{t.contact.form.success}</p>
                </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-137" data-mp="1k19l5ybpdw14">
                  <Field id="name" label={t.contact.form.name} required data-id="element-138" data-mp="1p0m6gemxev1l" />
                  <div className="grid sm:grid-cols-2 gap-5" data-id="element-139" data-mp="1oyrp1aav5l29">
                    <Field id="email" label={t.contact.form.email} type="email" required data-id="element-140" data-mp="1azry1vzvou2x" />
                    <Field id="phone" label={t.contact.form.phone} type="tel" required data-id="element-141" data-mp="1g17hjjmeqsj7" />
                  </div>
                  <Field id="company" label={t.contact.form.company} data-id="element-142" data-mp="114qb96t2s43i" />
                  <div data-id="element-143" data-mp="163b9j0orodpb">
                    <label htmlFor="message" className="block text-sm font-semibold text-navy mb-1.5" data-id="element-144" data-mp="162s0k9h3gznf">
                      {t.contact.form.message}
                    </label>
                    <textarea id="message" name="message" required rows={4} className="w-full rounded-sm border border-slate-300 bg-white px-4 py-2.5 text-navy outline-none transition-colors focus:border-orange focus:ring-1 focus:ring-orange" data-id="element-145" data-mp="30f86ta9w4dsa" />
                  </div>
                  <button type="submit" className="inline-flex w-full items-center justify-center gap-2 rounded-sm bg-orange px-6 py-3.5 text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-orange-dark" data-id="element-146" data-mp="tqzedlhq69um">
                    {t.contact.form.submit}
                    <SendIcon size={17} data-id="element-147" data-mp="1hfimo10rymmp" />
                  </button>
                </form>}
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}
function Field({
  id,
  label,
  type = "text",
  required = false
}: {
  id: string;
  label: string;
  type?: string;
  required?: boolean;
}) {
  return <div data-id="element-148" data-mp="1i7if5ger7qtn">
      <label htmlFor={id} className="block text-sm font-semibold text-navy mb-1.5" data-id="element-149" data-mp="1i7s7han9ua2i">
        {label}
        {required && <span className="text-orange" data-id="element-150" data-mp="1n6moc71ohojz"> *</span>}
      </label>
      <input id={id} name={id} type={type} required={required} className="w-full rounded-sm border border-slate-300 bg-white px-4 py-2.5 text-navy outline-none transition-colors focus:border-orange focus:ring-1 focus:ring-orange" data-id="element-151" data-mp="1r7orgyypukr8" />
    </div>;
}